import React from 'react';
import { Tag } from '../../../common/tags/tagTypes';
import { Tag as TagElement, TagGroup, TagList } from '@milanote/roma';
import { List } from 'immutable';

type TagElementPillsContainerProps = {
    tags: List<Tag>;
    size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
};

const TagElementPillsContainer: React.FC<TagElementPillsContainerProps> = ({ tags, size }) => {
    if (!tags.size) return null;

    return (
        <div className="TagElementPillsContainer mb-1 mr-1">
            <TagGroup label="Tags list mb-1" size={size}>
                <TagList className="flex flex-wrap gap-1">
                    {tags.map((tag) => {
                        if (!tag) return null;

                        return (
                            <TagElement key={tag.id} color={tag.color}>
                                {tag.name}
                            </TagElement>
                        );
                    })}
                </TagList>
            </TagGroup>
        </div>
    );
};

export default TagElementPillsContainer;
